import React from "react";
import DragableList from "./DragableList";
import { useBestOf } from "../../context/BestOf";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  gridItem: {
    backgroundColor: theme.palette.background.paper,
    textAlign: "center",
    borderRadius: "10px",
    boxShadow: "0.5px 0.5px 2px #999",
  }
}));

const CoverPage = () => {
  const classes = useStyles();
  const {state} = useBestOf();
  return (
    <div className={classes.gridItem}>
      <h3>Page de couverture</h3>
      <p style={{color: 'red'}}>{state.msgPostCover}</p>
      <DragableList key={'cover-page-1'} bestOffDay={state.postCover} day={null} />
    </div>
  );
};

export default CoverPage;